import React from "react";
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel";
import _ from "lodash";

import { GTM_PROJECT_CATEGORY } from "../utils/constants";
import { getGtmUserType, fireGtmEvent } from "../utils/functions";
import { withPrefix } from "gatsby";

export default function LocationCarousel(props) {
  const cardData = props.data.map((location) => {
    return {
      attractText: "",
      chinaURL: "",
      cndisclaimerLine1: "",
      cndisclaimerLine2: "",
      companyName: "",
      companyURL: "",
      countDown: "",
      cta: "",
      currencyCode: "",
      discount: "",
      hidden: "",
      image:
        location.image,
      imageAlt: `${location.title? location.title : location.title} on Airasia`,
      labelColor: "",
      location: "",
      mobileAppImageURL: "",
      newTab: "FALSE",
      position: "",
      price: "",
      priceClarification: "",
      priceDisclaimer: "",
      primaryLabel: "",
      productID: "",
      productType: "",
      rating: "",
      secondaryImage: "",
      secondaryLabel: "",
      star: "",
      subtitle: location.subtitle,
      timer: "",
      title: location.title? location.title : location.title,
      url: withPrefix(location.url),
    };
  });

  const gtmUserType = getGtmUserType();

  return (
    <Carousel
      accessible
      cardConfig={{
        focusEffect: true,
      }}
      data={[...cardData]}
      heading={{
        cardCount: "5",
        gtmParameters: {
          event: "trackEventNoEcommerce",
          eventActionClick: "click",
          eventActionView: "view",
          eventCategory: `${GTM_PROJECT_CATEGORY} | Internal Linking Carousel`,
          eventLabelCardClick: `${GTM_PROJECT_CATEGORY} | ${gtmUserType} | {{cardtitle}} | {{cardposition}} `,
          eventLabelHeadlineClick: `${gtmUserType}  | headline | {{headline}}`,
          eventLabelView: `${GTM_PROJECT_CATEGORY} | ${gtmUserType}`,
        },
        headline: "",
        layoutName: "lob_widget",
        showMoreURL: "",
        subHeadline: "",
        widgetID: "",
        widgetName: "Restaurant Lists Widget",
        widgetWidth: "3",
      }}
      fireGtm={(obj) => {
        fireGtmEvent(obj);
      }}
      isLoading={_.isEmpty(props.data)}
      templateType="productCard"
      lazyLoadImage={true}
      enableProgressiveImageLoading={true}
    />
  );
}
